/**
 * Статус задачи с сервера → состояние кнопки загрузки.
 *
 * Зачем отдельно. Задача может быть создана, но ещё не взята в работу: воркер
 * ждёт своей очереди. Раньше кнопка в этот момент показывала «Загрузка 0%» —
 * то есть уверяла, что качает, когда не качала ничего, и любая задержка
 * выглядела зависанием (08.08.2026: клик, три минуты неподвижной кнопки,
 * вопрос «что происходит»).
 *
 * Причину ожидания кнопке знать незачем — человеку важно, что его запрос принят
 * и стоит в очереди, а не что именно сейчас занято на сервере.
 */

/** Статусы, означающие «принято, но ещё не в работе». */
const QUEUED = new Set(['prepared', 'pending'])

export function isQueuedStatus(status: string): boolean {
  return QUEUED.has(status)
}
